import { BaseStoreEffects } from './base-store.effects';
import { BusinessRegionEffects } from './business-region.effects';
import { CitySearchEffects } from './city-search.effects';
import { GeoPointEffects } from './geo-point.effects';

export const effects: any[] = [GeoPointEffects, BusinessRegionEffects, CitySearchEffects, BaseStoreEffects];
